<template>
    <v-card>
        <v-container>
            <v-card-text>
                <h1 data-cy="lostPasswordChanged">{{ $t('passwordLost.changed.title') }}</h1>
            </v-card-text>
        </v-container>
    </v-card>
</template>

<script>
export default {};
</script>
